import PropTypes from 'prop-types';
import React from "react";
import {
  Row,
  Col,
  FormGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import isEqual from "is-equal";

import Button from "src/components/button";
// import InputField from "src/legacy/components/InputField";
import {Input} from "src/components/input";
// import { browserHistory } from "react-router";

import SwitchButton from "src/components/switchButton";
import ContactRow from "../../../../components/Contacts/ContactRow.jsx"
import InfiniteScroll from "src/components/infiniteScroll";
import _ from "lodash";


import PlaceholderEmptyMessage from "src/legacy/components/PlaceholderEmptyMessage";
import RolodexEmptyMessageSvgIcon from "src/legacy/images/rolodexEmptyMessage.svg";

import ContactsImportContainer from "../import";
import userRoleService from 'src/services/userRoles.service.js';
import { localizedStrings } from 'src/localization';

import cx from "classnames";
import styles from "./ContactListFormView.module.scss";
import RolodexContactFormContainer from "../../../rolodex/forms/RolodexContactFormContainer.jsx";
import Actions from 'src/components/actionbar';
import Loaders from 'src/pages/asset/components/generateLink/components/loadingPlaceHolder';


class ContactListFormView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      contactListId: this.props.contactList ? this.props.contactList.id : null,
      createContactView: false
    };

    this.state = this.getInitialState();

    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleBackClick = this._handleBackClick.bind(this);
    this._handleCreateClick = this._handleCreateClick.bind(this);
    this._handleNextClick = this._handleNextClick.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._toggleSelection = this._toggleSelection.bind(this);
    this.loadMoreContacts = this.loadMoreContacts.bind(this);

    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._handleToggleOption = this._handleToggleOption.bind(this);
    this._handleImportClick = this._handleImportClick.bind(this);
    this._handleCreateContact = this._handleCreateContact.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedDistributionList = this.localizatedSettings.distribution_lists;
    this.localizedAddContacts = this.localizedDistributionList.sliders.add_contacts;
    this.localizedEmptyMessage = this.localizedAddContacts.empty_message;
    this.localizedNewList = this.localizedDistributionList.sliders.create_new_list;
  }

  getInitialState() {
    return {
      name: "",
      query: "",
      contactListView: false,
      isGlobalListView: false,
      errors: {},
      importView: false,
    };
  }

  _handleImportClick() {
    this.setState({
      importView: true,
    });
  }

  _handleCreateContact(){
    this.setState({
      createContactView: true
    })
  }

  _handleCreateClick() {
    let contactList = {};

    let contacts = [];
    let contactListId;
    console.log(this.props);
    console.log(this.state.contactListId);
    
    
    if (this.props.contactList) {

      contactListId = this.props.contactList.id;
      contacts = this.props.contactList.contacts.map((item) => {
        return item.id;
      });
    } else if (this.state.contactListId) {
      contactListId = this.state.contactListId;
      contacts = this.props.selectedContacts.map((item) => {
        return item.id;
      });
    }

    if (contactListId) {
      contactList.contacts = contacts;

      this.props
        .updateContactList(contactListId, contactList)
        .then((response) => {
          if (response.type === "LEGACY_UPDATING_CONTACT_LIST_SUCCEDDED") {
           this.props.navigate(`/settings/contact_list/${contactListId}`);
            this.props.selectedContacts.forEach((contact) => {
              this.props.invalidateContactSelection(contact.id);
            });
          }
          this.props.onCancelClick();
        });
    }
  }

  _handleNextClick() {
    const errors = this.validateForm();
    let contactList = {};

    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors,
      });

      return;
    }

    contactList.name = this.state.name;
    this.props.createContactList(contactList).then((response) => {
      //todo check types properly
      if (response.type === "LEGACY_CREATING_CONTACT_LIST_SUCCEDDED") {
        this.props.navigate(`/settings/contact_list/${response.payload.id}`);
        this.props.fetchContacts(false, 0, "");
        this.setState({
          contactListId: response.payload.id,
        });
      }
    });
    this.props.onNextClick();
  }

  _handleCancelClick() {
    
    if (this.props.onCancelClick) {
      this.props.onCancelClick();
    }
  }

  _handleBackClick() {
    this.setState({
      importView: false,
    });
  }

  _handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
    });
  }

  validateForm() {
    let errors = {};
    const { name } = this.state;
    if (!name || name.trim() == "") {
      errors.name = this.localizedEmptyMessage.name;
    }

    return errors;
  }

  hasFieldError(field) {
    return this.state.errors[field];
  }

  renderAddButtonTitle() {
    if (this.props.updating && this.props.creating) {
      return `${this.localizedCommonActions.adding}...`;
    } else {
      return this.localizedCommonActions.add;
    }
  }

  componentDidMount() {
    this.props.fetchContacts(false, 0, "");

  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.isResetView, nextProps.isResetView)) {
      let initialState = this.getInitialState();
      this.setState({
        ...initialState,
      });
    }
    if (!this.props.contactListView && nextProps.contactListView) {
      this.props.fetchContacts(false, 0, "");
    }

    if (nextProps.contactList) {
      this.setState({
        contactListId: nextProps.contactList.id,
      });
    }

    if (this.props.createView && !nextProps.createView) {
      this.setState({
        name: "",
        errors: {},
      });
    }
  }

  _toggleSelection(contact) {
    var selected = this.props.isContactSelected(contact);

    if (this.props.contactList) {
      if (selected) {
        this.props.removeContactFromContactList(
          this.props.contactList.id,
          contact
        );
      } else {
        this.props.addContactToContactList(this.props.contactList.id, contact);
      }
    } else {
      if (selected) {
        this.props.deselectContact(contact);
      } else {
        this.props.selectContact(contact);
      }
    }
  }

  _handleSearch(event) {
    event.preventDefault();
    this.props.fetchContacts(this.state.isGlobalListView, 0, this.state.query);
  }

  _handleSearchQueryChange(e) {
    this.setState({
      query: e.target.value,
    });
  }

  _handleToggleOption(field, e) {
    this.setState({
      [field]: this.props.globalContactsEnabled && !this.state[field],
    });

    this.props.fetchContacts(!this.state[field], 0, this.state.query);
  }

  loadMoreContacts() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    this.props.fetchContacts(
      this.state.isGlobalListView,
      nextPage,
      this.state.query
    );
  }

  handleBackButtonClick(){
    this.props.handleBackButtonClick();
  }

  render() {
    return (
      <div className={cx(styles.content, this.props.className)}>
        <div className={styles.background}>&nbsp;</div>
        {!this.props.contactListView && (
          <Row className={styles.searchBody}>
            <Col sm={12} md={12} className={styles.column}>
              <h1 className={styles.pageTitle}>
                {this.props.contact ? (
                   this.localizedAddContacts.actions.update_contact
                ) : (
                  <span>{this.localizedNewList.title}</span>
                )}
              </h1>
            </Col>
            <Col sm={12} className={styles.fields}>
            <Input
              autoFocus
              placeholder={this.localizedNewList.search_placeholder}
              value={this.state.name}
              onChange={this._handleChange.bind(this, "name")}
            />
              {this.hasFieldError("name") && 
              <span className={styles.errorStyle}>
              <i className='fa fa-warning'/>
              {this.hasFieldError("name")}
              </span>
              }
            </Col>
            <Col sm={12} md={12} className={cx(styles.column,styles.actions)}>
             

                <Button 
                  text={this.localizedCommonActions.next}
                  variant='primary'
                  onClick={()=>this._handleNextClick()}
                  />  

                  <Button
                    text={this.localizedCommonActions.cancel}
                    onClick={()=>this._handleCancelClick()}
                  />
                
            </Col>
          </Row>
        )}
        {this.props.contactListView && !this.state.importView && userRoleService.canCreateContact() && (
          <div>
            <Row className={styles.body}>
            <div className={styles.iconHeader}>
            <span onClick={this.handleBackButtonClick} className={styles.backButton}><i className='paperflite-left-arrow'/> {this.localizedCommonActions.back}</span>

              <Actions.IconButton tooltip={this.localizedAddContacts.actions.upload_csv} icon="paperflite-upload" onClick={this._handleImportClick} />
             
            </div>
              <Col sm={12} md={12} className={cx(styles.column, styles.top)}>
                <h1 className={styles.pageContentTitle}>
                  {this.props.contact ? (
                    this.localizedAddContacts.actions.update_contact
                  ) : (
                    <span>{this.localizedAddContacts.actions.add_contact}</span>
                  )}
                </h1>
                {this.props.globalContactsEnabled ? (
                  <div className={styles.globalToggle}>
                    <SwitchButton
                      className={styles.switch}
                      name={`global_contacts_${new Date().getTime()}`}
                      handleCheck={this._handleToggleOption.bind(
                        this,
                        "isGlobalListView"
                      )}
                      id="global_contacts"
                      checked={this.state.isGlobalListView}
                    />
                    <span className={styles.label}>{this.localizedAddContacts.view_global_contacts}</span>
                  </div>
                ): (
                  <label>{this.localizedAddContacts.sub_text}</label>
                )}

                <p className={styles.addContact} onClick={this._handleCreateContact}>
                  <i className='paperflite-add' />
                  {this.localizedAddContacts.actions.add_contact}
                </p>
                <form className={styles.search} onSubmit={this._handleSearch}>
                  <FormGroup className={styles.formGroup}>
                    <InputGroup className={styles.inputGroup}>
                      <InputGroup.Text className={styles.addon}>
                        <span
                          className={cx(styles.icon, "paperflite-search")}
                        ></span>
                      </InputGroup.Text>
                      <FormControl
                        type="text"
                        placeholder={this.localizedAddContacts.placeholder.search}
                        className={styles.formControl}
                        value={this.state.query}
                        onChange={this._handleSearchQueryChange}
                      />
                    </InputGroup>
                   
                  </FormGroup>
                </form>
              </Col>
              <div className={styles.list}>
                <div
                  className={styles.inner}
                  ref={(element) => {
                    this.scrollContainer = element;
                  }}
                >
                  {this._renderContacts()}
                </div>
              </div>
            </Row>
            <div className={styles.actionsAdd}>
              <Button
                onClick={() => {
                  this._handleCreateClick();
                }}
                text={this.renderAddButtonTitle()}
                disabled={this.props.updating || this.props.creating}
                variant="primary"
              />
              <Button
                onClick={() => {
                  this._handleCancelClick();
                }}
                text={this.localizedCommonActions.cancel}
              />
              </div>
          </div>
        )}
        {this.state.importView && (
          <ContactsImportContainer
            type="ContactList"
            handleCancelClick={() => this._handleCancelClick()}
            handleBackClick={() => this._handleBackClick()}
            contactListId={this.state.contactListId}
            contactCount={this.props.contactList ? this.props.contactList.contactCount : null}
          />
        )}
        {this.state.createContactView &&
        <div className={styles.createContactView}>
          <RolodexContactFormContainer
            contactList={this.props.contactList ? this.props.contactList : null}
            location={this.props.location}
            onCancelClick={this._handleCancelClick}
            isResetView={this.state.resetView}
            onHideCreateView={() => this.setState({ createContactView: false})}
          />
        </div>
        }
      </div>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedEmptyMessage.title}
        message={this.localizedEmptyMessage.sub_text}
        image={RolodexEmptyMessageSvgIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderContacts() {
    if (!this.props.contacts) {
      return null;
    }

    if (
      !this.props.loading &&
      this.props.contacts.length == 0 &&
      this.props.query != ""
    ) {
      return this._renderEmptyMessage();
    }

    let contacts = Array();

    this.props.contacts.forEach((contact, index) => {
      var selected = this.props.isContactSelected(contact);
      var disabled = this.isContactSelectionDisabled(contact);
      
      contacts.push(
    
          <ContactRow
            editable="true"
            key={contact.id}
            ref={`${contact.id}-contact`}
            contact={contact}
            onSelection={this._toggleSelection}
            selected={selected}
            disabled={disabled}
            showBorders={true}
          />
  
      );
    });

    return (
      <InfiniteScroll
       hasMore={this.props.currentPage < this.props.totalPages}
      loader={() => [1,2,3].map((i)=> <Loaders key={i}/> )}
      loadMore={this.loadMoreContacts}
      loading={this.props.loading}
    >
         {contacts}
     </InfiniteScroll>
    );
  }

  isContactSelectionDisabled(contact) {
    var disabled = this.props.isContactDisabled(contact);
    if(disabled){
      return disabled;
    }

    var selected = this.props.isContactSelected(contact);
    if(selected){
      return false;
    }

    if (this.props.contactList && _.size(this.props.contactList.contacts) >= 100){
      return true;
    }

  }
}

export default ContactListFormView;
